import * as React from "react";
import { Fragment } from "react";
import { Paragraph } from "scuid-x";
import MarblesImg from "../assets/images/marbles.svg";
import { GenErrorPage } from "../components/GenErrorPage";
import { Routes } from "../constants/Routing";
import "./Marbles.css";

export const Marbles: React.SFC<any> = () => {
  const description = (
    <Paragraph>
      We&apos;ve lost our marbles! Please return to
      your {Routes.getReturnDevice()} and
      try again.
    </Paragraph>
  );

  return (
    <GenErrorPage
      title="Uh oh!"
      description={description}
    >
      <Fragment>
        <img
          className={"Marbles-image"}
          src={MarblesImg}
          alt="marbles"
        />
      </Fragment>
    </GenErrorPage>
  );
};



// WEBPACK FOOTER //
// ./src/screens/Marbles.tsx